import { render } from "./NavActionButtons.vue?vue&type=template&id=1f232f15&scoped=true"
import script from "./NavActionButtons.vue?vue&type=script&lang=js"
export * from "./NavActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f232f15"]])

export default __exports__